import { inject, Injectable, Injector } from '@angular/core';
import { UserAuthService } from '@shared/modules/auth/auth-data-access/user-auth.service';
import { applyThemes } from '@shared/modules/color-scheme/common/helpers/apply-themes';
import { migration_v1$ } from '@shared/modules/app/migrations/migration_v1';
import { catchError, tap } from 'rxjs/operators';
import { LoginUserModel, UserModel } from '@dta/shared/models-api-loop/contact/contact.model';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { StorageKey, StorageService } from '@dta/shared/services/storage/storage.service';

@Injectable()
export class AppLoadService {
  private readonly injector: Injector = inject(Injector);
  private readonly userAuthService: UserAuthService = inject(UserAuthService);
  private readonly storageService: StorageService = inject(StorageService);

  initApp(): Observable<any> {
    return migration_v1$(this.injector).pipe(
      switchMap(() => this.userAuthService.resolveActiveUser$()),
      switchMap(activeUserId => {
        if (!activeUserId) {
          this.userAuthService.handleNoActiveUser();
          applyThemes(this.injector);
          return of(null);
        }

        return this.userAuthService.loadCurrentSession$(this.storageService.getItem(StorageKey.nextWorkspaceId)).pipe(
          tap(currentSession => {
            this.storageService.removeItem(StorageKey.nextWorkspaceId);
            if (!currentSession) {
              applyThemes(this.injector);
              return;
            }

            applyThemes(this.injector, currentSession);
          }),
          catchError(err => {
            if (err.status === 451) {
              let loginUser = new LoginUserModel(new UserModel());
              loginUser.throwVerifiedError = true;
              return of(loginUser);
            }

            return throwError(err);
          })
        );
      })
    );
  }
}
